import * as THREE from 'three/webgpu';
import { markSharedInteractionMaterial } from './materialOwnership';

/** 测量选中统一绿色（面、线框、点同色，对齐 SolidWorks Measure 选中语义）。 */
export const MEASURE_SELECTED_COLOR = 0x00b050;

/** 测量选中面/线不透明度（不透明）。 */
export const MEASURE_SELECTED_OPACITY = 1;

/** 测量选中面材质名称。 */
export const MEASURE_SELECTED_FACE_MATERIAL_NAME = '测量选中面材质';

/** 测量选中线框材质名称。 */
export const MEASURE_SELECTED_LINE_MATERIAL_NAME = '测量选中线框材质';

/**
 * 测量选中材质工厂。
 *
 * 设计说明：
 * 1. 测量选中颜色与面/线材质配方统一收口到 material 层，避免 measure 模块散落常量；
 * 2. 面与线材质采用单例缓存复用，点材质由 `PointsMaterialFactory` 复用本文件导出的颜色常量；
 * 3. 前景叠加语义与 `FeatureFace` 一致：`depthTest=false + depthWrite=false`。
 */
export class MeasureSelectionMaterialFactory {
    /** 测量选中面材质缓存。 */
    private static selectedFaceMaterial: THREE.MeshStandardMaterial | null = null;

    /** 测量选中线框材质缓存。 */
    private static selectedLineMaterial: THREE.LineBasicMaterial | null = null;

    /**
     * 获取测量选中面材质（单例缓存复用）。
     *
     * @returns 绿色不透明面材质。
     */
    public static getSelectedFaceMaterial(): THREE.MeshStandardMaterial {
        if (MeasureSelectionMaterialFactory.selectedFaceMaterial) {
            return MeasureSelectionMaterialFactory.selectedFaceMaterial;
        }

        MeasureSelectionMaterialFactory.selectedFaceMaterial = markSharedInteractionMaterial(
            new THREE.MeshStandardMaterial({
                name: MEASURE_SELECTED_FACE_MATERIAL_NAME,
                color: MEASURE_SELECTED_COLOR,
                transparent: true,
                opacity: MEASURE_SELECTED_OPACITY,
                depthTest: false,
                depthWrite: false,
                side: THREE.DoubleSide,
                polygonOffset: true,
                polygonOffsetFactor: -2,
                polygonOffsetUnits: -2,
            }),
        );
        return MeasureSelectionMaterialFactory.selectedFaceMaterial;
    }

    /**
     * 获取测量选中线框材质（单例缓存复用）。
     *
     * @returns 绿色不透明线材质。
     */
    public static getSelectedLineMaterial(): THREE.LineBasicMaterial {
        if (MeasureSelectionMaterialFactory.selectedLineMaterial) {
            return MeasureSelectionMaterialFactory.selectedLineMaterial;
        }

        MeasureSelectionMaterialFactory.selectedLineMaterial = markSharedInteractionMaterial(
            new THREE.LineBasicMaterial({
                name: MEASURE_SELECTED_LINE_MATERIAL_NAME,
                color: MEASURE_SELECTED_COLOR,
                transparent: true,
                opacity: MEASURE_SELECTED_OPACITY,
                depthTest: false,
                depthWrite: false,
            }),
        );
        return MeasureSelectionMaterialFactory.selectedLineMaterial;
    }
}
